// extracted by mini-css-extract-plugin
module.exports = {"HeaderDesktopWrapper":"index-module--HeaderDesktopWrapper--3XUSF","HeaderDesktop":"index-module--HeaderDesktop--B30qa"};